import React, { useState } from "react";
import { debounceFunc } from "../../utilities/utilities";
import { Button, Dialog, DialogTitle, DialogActions } from "@mui/material";
import { useTranslation } from "react-i18next";

type ButtonConfProps = {
  buttonType?: "text" | "contained" | "outlined";
  buttonLabel: string;
  buttonOnConfirm: any;
  questionLabel?: string;
  yesLabel?: string;
  noLabel?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  size?: "small" | "medium" | "large";
};

const ButtonConfItem: React.FC<ButtonConfProps> = ({
  buttonType,
  buttonLabel,
  buttonOnConfirm,
  questionLabel,
  yesLabel,
  noLabel,
  disabled,
  fullWidth,
  size,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState<boolean>(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Button
        size={size ? size : undefined}
        variant={buttonType ?? "outlined"}
        id={buttonLabel}
        data-testid={buttonLabel}
        disabled={disabled ? disabled : undefined}
        onClick={handleOpen}
        style={{
          color: buttonType && buttonType !== "outlined" ? "white" : "#5c4424",
          border: "1px solid #5c4424",
          backgroundColor:
            buttonType && buttonType !== "outlined" ? "#5c4424" : undefined,
          fontFamily: "Montserrat, sans-serif",
        }}
        fullWidth={fullWidth ? fullWidth : undefined}
      >
        {buttonLabel}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
      >
        <DialogTitle id="alert-dialog-title">
          {questionLabel ?? t("sureQuestion")}
        </DialogTitle>
        <DialogActions>
          <Button
            onClick={debounceFunc(() => {
              buttonOnConfirm();
              handleClose();
            })}
          >
            {yesLabel ?? t("yes")}
          </Button>
          <Button onClick={debounceFunc(handleClose)} autoFocus>
            {noLabel ?? t("no")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ButtonConfItem;
